import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AnyIntegration, IIntegrationKelseysMenu } from '../../../../interfaces/restaurant';

type EditIntegrationKelseysMenuForm = {
  proxy: FormControl<boolean>;
  proxyUnifiedMode: FormControl<boolean>;
  storeNumber: FormControl<string>;
};

@UntilDestroy()
@Component({
  selector: 'app-edit-integration-kelseys-menu',
  templateUrl: './edit-integration-kelseys-menu.component.html',
  styleUrls: ['./edit-integration-kelseys-menu.component.scss']
})
export class EditIntegrationKelseysMenuComponent implements OnInit {

  @Input() set data(value: AnyIntegration) {

    if (value && value.provider === 'kelseysMenu') {
      const kelseysValue = value as IIntegrationKelseysMenu;

      this.editIntegrationForm.get('proxy')?.setValue(kelseysValue.proxy ?? false, { emitEvent: false });
      const proxyUnifiedModeControl = this.editIntegrationForm.get('proxyUnifiedMode');

      if (kelseysValue.proxy) {
        proxyUnifiedModeControl?.enable({ emitEvent: false });
        proxyUnifiedModeControl?.setValue(kelseysValue.proxyUnifiedMode ?? false, { emitEvent: false });
      } else {
        proxyUnifiedModeControl?.disable({ emitEvent: false });
        proxyUnifiedModeControl?.setValue(false, { emitEvent: false });
      }

      this.editIntegrationForm.patchValue(kelseysValue.credentials);
    }
  }

  public editIntegrationForm: FormGroup<EditIntegrationKelseysMenuForm> = new FormGroup({
      proxy: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.required] }),
      proxyUnifiedMode: new FormControl(
        {value: false, disabled: true},
        { nonNullable: true, validators: [Validators.required] }
      ),
      storeNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.pattern('^[0-9]*$'), Validators.maxLength(255)]
      })
    }
  );

  @Output() edited = new EventEmitter<Partial<AnyIntegration>>();
  @Output() remove = new EventEmitter<void>();

  constructor(
    public dialogRef: MatDialogRef<any>,
    public notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.addListeners();
  }

  private addListeners(): void {
    this.editIntegrationForm.get('proxy')?.valueChanges.pipe(
      untilDestroyed(this)
    ).subscribe((proxyValue: boolean) => {
      const proxyUnifiedModeControl = this.editIntegrationForm.get('proxyUnifiedMode');

      if (!proxyValue) {
        proxyUnifiedModeControl?.disable({emitEvent: false});
        proxyUnifiedModeControl?.setValue(false, { emitEvent: false });
      } else {
        proxyUnifiedModeControl?.enable({emitEvent: false});
      }
    });
  }

  public edit(): void {
    const formValue = this.editIntegrationForm.getRawValue();

    this.edited.emit({
      proxy: formValue.proxy,
      proxyUnifiedMode: formValue.proxyUnifiedMode,
      credentials: {
        storeNumber: formValue.storeNumber,
      }
    });
  }

  public removeIntegration(): void {
    this.remove.emit();
  }
}
